// @tensorflow/tfjs Copyright 2019 Google
import { version_core } from "@tensorflow/tfjs-core";
export * from "@tensorflow/tfjs-core";
import { version_layers } from "@tensorflow/tfjs-layers";
export * from "@tensorflow/tfjs-layers";
import { version_converter } from "@tensorflow/tfjs-converter";
export * from "@tensorflow/tfjs-converter";
import * as tfjsData from "@tensorflow/tfjs-data";
import { version_data } from "@tensorflow/tfjs-data";
export { tfjsData as data };
var version = "1.2.2",
    version$1 = {
  "tfjs-core": version_core,
  "tfjs-data": version_data,
  "tfjs-layers": version_layers,
  "tfjs-converter": version_converter,
  tfjs: version
};
export { version$1 as version };